import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface IPracticeRevisionFilterStoreState {
  exam: string[];
  list: string[];
  discipline: string[];
  setExam: (exam: string[]) => void;
  setList: (list: string[]) => void;
  setDiscipline: (discipline: string[]) => void;
  reset: () => void;
}

export const practiceRevisionFilterStore = create<IPracticeRevisionFilterStoreState>()(
  persist(
    (set) => ({
      exam: [],
      list: [],
      discipline: [],
      setExam: (exam: string[]) => set({ exam }),
      setList: (list: string[]) => set({ list }),
      setDiscipline: (discipline: string[]) => set({ discipline }),
      reset: () => set({
        exam: [],
        list: [],
        discipline: [],
      })
    }),
    {
      name: 'practice-revision-filters'
    }
  )
);